import type { IProductImage } from 'types';

export function getThumbnailSrc(image: IProductImage) {
  return image?.thumbnail?.default || image?.large?.default;
}
